module.exports = "{{'password-changed-success-message' | translate }}<br><br>\n<button type=\"submit\" class=\"btn btn-primary btn-app-b pop-btn-dim\" (click)=\"closeRecoverPop()\">{{'cancel' | translate }}</button>\n<button type=\"submit\" class=\"btn btn-primary btn-app-b\" (click)=\"Login()\">{{'Login' | translate }}</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/recover-password-succ/recover-password-succ.component.html
// module id = ./src/app/shared/recover-password-succ/recover-password-succ.component.html
// module chunks = main